import type { TableProps } from 'antd';
import { DataType } from './types';

export const columns: TableProps<DataType>['columns'] = [
  {
    title: 'Фамилия',
    dataIndex: 'surname',
  },
  {
    title: 'Имя',
    dataIndex: 'name',
  },
  {
    title: 'Отчество',
    dataIndex: 'patronymic',
  },
  {
    title: 'Почта',
    dataIndex: 'email',
  },
  {
    title: 'Статус верефикации',
    dataIndex: 'verified',
  },
  {
    title: 'Является администратором',
    dataIndex: 'admin',
  },
  {
    title: 'Действия',
    dataIndex: 'actions',
  },
];
